/* eslint-disable unicorn/filename-case */
import { assertNever } from '@squareup/dex-utils-shared-assert-never';

import { PropertyCategory } from '../PropertyInfo';

const getAnchorPrefix = (propertyCategory: PropertyCategory): string | null => {
  switch (propertyCategory) {
    case PropertyCategory.Definitions:
      // Example URL: /objects/FloatNumberRange#definition__property-start_at
      return 'definition';
    case PropertyCategory.ErrorDescriptions:
      // Example URL: /payments-api/create-payment#error__property-ADDRESS_VERIFICATION_FAILURE
      return 'error';
    case PropertyCategory.EventPayload:
      /*
       * Note: No anchor category prefix is used for webhook event payloads
       * Example URL: /payments-api/webhooks/payment.created#property-merchant_id
       */
      return null;
    case PropertyCategory.PathParameters:
      // Example URL: /payments-api/get-payment#path__property-payment_id
      return 'path';
    case PropertyCategory.QueryParameters:
      // Example URL: /payments-api/list-payments#query__property-begin_time
      return 'query';
    case PropertyCategory.RequestBody:
      // Example URL: /payments-api/update-payment#request__property-payment
      return 'request';
    case PropertyCategory.ResponseFields:
      // Example URL: /payments-api/list-payments#response__property-errors
      return 'response';
    default:
      return assertNever(propertyCategory);
  }
};

export const usePropertyAnchor = (
  propertyCategory: PropertyCategory | null,
  propertyName: string
): string | null => {
  if (propertyCategory === null) {
    return null;
  }

  const anchorPrefix = getAnchorPrefix(propertyCategory);
  const anchorPropertyName = `property-${propertyName}`;

  return anchorPrefix
    ? `${anchorPrefix}__${anchorPropertyName}`
    : anchorPropertyName;
};
